module.exports = new __parcel__URL__("12877_sq.5ceecae5.jpg").toString();